<template>
  <template v-if="user && user?.role_id == 4">
    <DashboardDriver />

  </template>

  <template v-if="user && user?.role_id == 3">
    <DashboardModera />

  </template>
  <!-- <div class="row">
   
    <div class="col-xxl-7 col-xxxl-6">
      <WhatHappening />

      <div class="row">
        <div class="col-lg-6 col-xxxl-6 col-md-6">
          <ExpectedEarnings />
        </div>
        <div class="col-lg-6 col-xxxl-6 col-md-6">
          <AverageDailySales />
        </div>
        <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
          <RevenueThisMonth />
        </div>
        <div class="col-xl-12 col-lg-6 col-xxxl-6 col-md-12">
          <NewCustomersThisMonth />
        </div>
      </div>
    </div>
    <div class="col-xxl-5 col-xxxl-6">
      <StatsBoxes />

      <WeeklySales />
    </div>
    <div class="col-xxl-4">
      <SalesByPOSLocation />
    </div>
    <div class="col-xxl-4">
      <TopSellingProducts />
    </div>
    <div class="col-xxl-4">
      <WebsiteVisitors />
    </div>
    <div class="col-xxl-6">
      <ProductsOrders />
    </div>
    <div class="col-xxl-6">
      <StockReport />
    </div>
  </div> -->
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DashboardDriver from "./Driver/DashboardDriver.vue";

import DashboardModera from "./Moderator/DashboardModera.vue";

import api from "@/utils/axios";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "EcommercePage",
  components: {
   
    DashboardDriver,
    DashboardModera
  },

  setup() {
      const auth = useAuthStore();
    const user = auth.user;
    // Any setup logic can go here
    const handleLogin = async () => {

      // console.log(localStorage.getItem("authToken"));
      // console.log("User data:", auth.token, auth.user);
      // const res = await api.get("/api/auth/SituationColis");
      // console.log("Situation Colis:", res.data);
    };

    return {
      handleLogin,
      user,
    };
  },
});
</script>